import styled from "styled-components";

const statuses = {
  rescheduling: "#f5b120",
  open: "#1133f9",
  closed: "#423d3c",
  canceled: "#968281",
  rejected: "#e22318",
  confirmed: "#19a049",
  approved: "#166b34",
  settled: "#4ae0bf"
};

export default styled.div.attrs({
  className: "fw6"
})`
  color: ${({ children }) => statuses[children.toLowerCase()]};
`;



// WEBPACK FOOTER //
// ./src/components/generic/kit/Status/index.js